import React from 'react';
import { Outlet } from 'react-router-dom';

const PredictLayout: React.FC = () => <Outlet />;

export default PredictLayout;
